module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column",
    staticStyle: {
      "background-color": "#eee"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-ursonate_note-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-column",
    staticStyle: {
      "position": "absolute",
      "height": "100%",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.midiData) ? _c('PlayerControls', {
    attrs: {
      "duration": _vm.duration,
      "currentTime": _vm.currentTime,
      "media": _vm.midiData,
      "mediaType": 'midi',
      "mediaName": _vm.meiName
    },
    on: {
      "seekbarChange": _vm.seekbarChange,
      "playPause": _vm.playPause
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(1)], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate_note"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-y-center",
    staticStyle: {
      "position": "absolute",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate_player",
    staticStyle: {
      "height": "0px",
      "overflow": "hidden",
      "width": "0px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e7cbf7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/texte/ursonate/NotenPlayer.vue
// module id = 1959
// module chunks = 1